import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Box, Typography, TextField } from "@mui/material";
import { useEffect, useState } from "react";

const ControlledSubjectiveFeedback = () => {
    const { control, setValue } = useFormContext();
    const [selectedQuestion, setSelectedQuestion] = useState<string>("");

    const subjectiveQuestions = [
        "How could this role play have been improved?",
        "Did you face any technical difficulties in completing this role play?",
        "Were you clear about the goals of the role play?",
        "How could the role play have been made more realistic?",
        "Any feedback for us?",
    ];

    useEffect(() => {
        // Randomly select one question when component mounts
        const randomIndex = Math.floor(Math.random() * subjectiveQuestions.length);
        const question = subjectiveQuestions[randomIndex];
        setSelectedQuestion(question);
        // Store the selected question in the form for API access
        setValue("selected_question", question);
    }, [setValue]);

    return (
        <Controller
            control={control}
            name="subjective_feedback"
            render={({ field }) => (
                <Box sx={{ width: "100%" }}>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        {selectedQuestion}
                    </Typography>
                    <TextField
                        {...field}
                        multiline
                        rows={4}
                        fullWidth
                        placeholder="Please share your thoughts..."
                        variant="outlined"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                "&:hover fieldset": {
                                    borderColor: "primary.main",
                                },
                            },
                        }}
                    />
                </Box>
            )}
        />
    );
};

export default ControlledSubjectiveFeedback; 